export enum ReportKind {
	summary = 'summary',
	revenues = 'revenues',
	expenditures = 'expenditures',
	debtLiabilities = 'debt-liabilities',
	revenuesOtherIncreases = 'revenues-other-increases',
	expendituresOtherDecreases = 'expenditures-other-decreases'
}
